import React, { useState } from 'react';
import './FileManager.css';
import * as api from 'api.js';
import { useGlobalState } from 'hooks';
import { FileEditModal } from './FileManagerModals.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faEdit } from '@fortawesome/free-solid-svg-icons';

export function FileManager() {
    const [state, dispatch] = useGlobalState();

    return (
        <div className="file_manager_main_cont">
            <div className="blue_top_bar user_info_line_bold">
                {state.currentPath.length > 2 && (
                    <>
                        <FontAwesomeIcon icon={faFile} />
                        &nbsp;
                        {state.selectedFile.name}
                    </>
                )}
            </div>
            {state.currentPath.length > 2 && (
                //files
                <FileControls />
            )}
        </div>
    );
}

/*
function FolderControls({ state }) {
    const [show, setShow] = useState(false);
    const pathLength = state.currentPath.length;
    let pathLevel = '';

    if (pathLength === 0) {
        pathLevel = 'folder';
    } else if (pathLength === 1) {
        pathLevel = 'speed class';
    } else if (pathLength === 2) {
        pathLevel = 'vendor';
    }

    return (
        <div className="file_manager_folder_controls_cont">
            <Button type="button" onClick={() => setShow(true)}>
                Add new {pathLevel}
            </Button>
            <FolderCreateModal show={show} setShow={setShow} type={pathLevel} />
        </div>
    );
}
*/
/*
function FolderControls({ state }) {
    const [show, setShow] = useState(false);
    const pathLength = state.currentPath.length;
    let pathLevel = '';

    if (pathLength === 1) {
        pathLevel = 'speed class';
    } else if (pathLength === 2) {
        pathLevel = 'vendor';
    }

    return (
        <div className="file_manager_folder_controls_cont">
            {pathLevel && (
                <button className="styled_button" type="button" onClick={() => setShow(true)}>
                    <FontAwesomeIcon icon={faPlus} />
                    &nbsp;ADD NEW {pathLevel.toUpperCase()}
                </button>
            )}
            <FolderCreateModal show={show} setShow={setShow} type={pathLevel} />
        </div>
    );
}
*/

function FileControls() {
    const [showEditModal, setShowEditModal] = useState(false);
    const [state, dispatch] = useGlobalState();

    return (
        <>
            {state.selectedFile.name && (
                <>
                    <div className="file_manager_file_info_cont">
                        <div className="user_info_line user_info_line_bold user_info_line_left_align">
                            Modification date:
                        </div>
                        <div className="user_info_line user_info_line_left_align">
                            {new Date(state.selectedFile.modified).toLocaleString('fi-FI')}
                        </div>
                        <div className="user_info_line user_info_line_bold user_info_line_left_align">
                            Description:
                        </div>
                        <div className="user_info_line user_info_line_left_align">
                            {!state.selectedFile.metadata.description ? (
                                <span className="missing_metadata">No description available.</span>
                            ) : (
                                state.selectedFile.metadata.description
                            )}
                        </div>
                        <div className="user_info_line user_info_line_bold user_info_line_left_align">
                            Additional info:
                        </div>
                        <div className="user_info_line user_info_line_left_align">
                            {!state.selectedFile.metadata.additional_info ? (
                                <span className="missing_metadata">
                                    No additional info available.
                                </span>
                            ) : (
                                state.selectedFile.metadata.additional_info
                            )}
                        </div>
                    </div>
                    <div className="file_manager_edit_binary_cont">
                        <button
                            type="button"
                            className="styled_button"
                            onClick={() => setShowEditModal(true)}
                        >
                            <FontAwesomeIcon icon={faEdit} />
                            &nbsp;EDIT BINARY
                        </button>
                        <FileEditModal show={showEditModal} setShow={setShowEditModal} />
                    </div>
                </>
            )}
        </>
    );
}
